export enum ELocalStorageKeys {
  FB_ID = "fbid",
  FB_PROFILE_PIC = "fbProfilePic",
}
